import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AppFooter from "../components/AppFooter";

const AIDisclaimer = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-cyan-50 to-blue-100 relative overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-white/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-cyan-300/30 rounded-full blur-3xl"></div>

      {/* Grid Overlay */}
      <div className="absolute inset-0 opacity-[0.05] bg-[linear-gradient(to_right,#0f172a_1px,transparent_1px),linear-gradient(to_bottom,#0f172a_1px,transparent_1px)] bg-[size:40px_40px]"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 py-10">

        {/* HEADER */}
        <div className="text-center mb-12">

          <div className="inline-flex items-center px-5 py-2 rounded-full bg-white/70 border border-cyan-200 backdrop-blur-xl text-cyan-700 shadow-lg text-sm">
            AICA HEALTH POLICY
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl font-bold text-slate-800">
            AI Disclaimer
          </h1>

          <p className="mt-4 text-slate-600 max-w-2xl mx-auto text-sm sm:text-base">
            Transparency notice regarding artificial intelligence systems, limitations, and medical safety boundaries.
          </p>
        </div>

        {/* CONTENT CARD */}
        <div className="relative overflow-hidden rounded-3xl border border-white/40 bg-white/60 backdrop-blur-2xl shadow-xl p-6 sm:p-8">

          {/* soft shine */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/30 to-transparent pointer-events-none"></div>

          <div className="relative z-10">
            <p className="text-slate-700 whitespace-pre-line leading-relaxed text-sm sm:text-base">

The Platform utilizes:

● artificial intelligence  
● machine learning  
● automated inference systems  
● conversational AI technologies  

AI-generated outputs:

● may be incomplete  
● may contain inaccuracies  
● may vary across users and environments  
● may be calibration-dependent  
● may evolve over time through model refinement  

Outputs generated by the Platform:

● are informational only  
● do not constitute diagnosis  
● should not be relied upon as the sole basis for medical decisions  

Human review and professional medical judgment remain essential.

AICA does not guarantee:

● clinical accuracy  
● uninterrupted operation  
● error-free outputs  
● medical outcomes  

            </p>
          </div>
        </div>

        {/* FOOTER */}
        <div className="mt-10 flex justify-center">

          <button
            onClick={() => navigate("/")}
            className="
            flex items-center gap-2
            px-6 py-3
            rounded-2xl
            bg-gradient-to-r from-cyan-500 to-blue-500
            text-white
            font-semibold
            shadow-lg
            hover:scale-105
            hover:shadow-cyan-300/50
            transition-all duration-300
          "
          >
            <ArrowLeft size={18} />
            Go Back
          </button>

        </div>

      {/* FOOTER */}
      {/* <AppFooter /> */}
       

      </div>
    </div>
  );
};

export default AIDisclaimer;